import Card from "react-bootstrap/Card"
import { useCallback, useEffect, useState } from "react";
import { FaFilter } from "react-icons/fa";
import { MtmChart } from "../../components/Charts/MtmChart";
import { DrawdownChart } from "../../components/Charts/DrawdownChart";
import { TargetSlChart } from "../../components/Charts/TargetSlChart";
import { HeatMap } from "../../components/HeatMap";
import { NoOfCallsCard } from "../../components/cards/NoOfCallsCard";
import { SuccessRatioCard } from "../../components/cards/SuccessRatioCard";
import { PLCard } from "../../components/cards/PLCard";
import "./style.css"
import HistoricalDataTable from "../../components/historicalDataTable/HistoricalDataTable";
import { useParams } from "react-router-dom";
import { getStartEndDateSF } from "../../api/historicalEndPoints/stockFutIntraday";
import { useDispatch, useSelector } from "react-redux";
import Filter from "../../components/filter/Filter";
import {getPLPercentageResponse, handleVersion } from "../../services/util/historicalComponentsResponses";
import { IoBarChartSharp } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import moment from "moment";
import { MdArrowRightAlt } from "react-icons/md";
import Performance from "../../components/modelPerformance/Performance";
import { getPrivilegedCodeAndSymbol,getPrivilegedCodeAndSymbolBank } from "../../api/otherEndPoints/necessoryEndPoints";
import OptionPerformance from "../../components/modelOptionPerformance/OptionPerformance";
import { DataTable, DataTableFilterMeta } from "primereact/datatable";
import { Column } from "primereact/column";
import { getEquityReturnDetails, getMonthlyRollingChartValue, getRollingChartValue, getRollingPdf, getSymbolOptions } from "../../api/otherEndPoints/historicalPerformance";
import 'primeicons/primeicons.css';
import { Row } from "react-bootstrap";
import { FilterMatchMode } from "primereact/api";
import { Dropdown } from "primereact/dropdown";
import Highcharts, { theme } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import CustomDateRange from "../../components/customDateRange/CustomDateRange";
import csvDownload from "json-to-csv-export";
import { Button } from "primereact/button";
import RelatedHeatMap from "./RelatedHeatMap";
import { setPreviewTableData } from "../../store/PreviewTableSlice";
import { generaliseExportCSV, monthlyReturnsMapping, monthlyReturnsMappingTableHeader, optionsRollingMapping, optionsRollingMappingTableHeader, rollingMapping, rollingMappingTableHeader } from "../../services/util/util";
import GeneralisePreviewTable from "../../components/adviceStatus/GeneralisePreviewTable";


const Historical = () => {
    const { type }: any = useParams()
    const dispatch:any = useDispatch();

    const [asset, setAsset] = useState<any>()
    const [tradetype, setTradetype] = useState<any>('Total')
    const [startandEndDate, setStartAndEndDate] = useState<any>(null)
    const [filterData, setFilterData] = useState<any>({
        'All': true,
        'start_date': false,
        'end_date': false,
        'Current_contract': true,
    })
    const [viewCharts, setViewCharts] = useState<any>(false)
    const [versions, setVersions] = useState<any>([])
    const [mtmDrawdownResponse, setMtmDrawdownResponse] = useState<any>([])
    const [filter, setFilter] = useState<boolean>(false);
    const [filterDropdownVersion, setFilterDropdownVersion] = useState<any>([])
    const [filterFinalObject, setFilterFinalObject] = useState<any>({})
    const [heatmapVersion, setHeatmapVersion] = useState<any>('all')
    const [dateFilter, setDateFilter] = useState<any>('Current_contract')
    const [currContractDiv, setCurrContractDiv] = useState<boolean>(true)
    const [hetmapPlPoints, setHeatmapPlPoints] = useState<any>(0)
    const [returnType, setReturnType] =useState<any>('reInvestment')
    const [activeButton, setActiveButton] = useState<string>('historicalEquity');
    const [selectedComponent, setSelectedComponent] = useState<string>('historicalEquity');
    const [heatMapData, setHeatMapData] = useState<any>([])
    const [boxShadow, setboxShadow] = useState<any>(0)
    let heatMapClicked = false
    const [allSymbols, setAllSymbols] = useState<any>([]); //NEW
    const [privilegedCodeAndSymbol, setPrivilegedCodeAndSymbol] = useState<any>([]);
    const [currData, setCurrData] = useState<any>([]);
    const [symbolsOptions, setSymbolsOptions ] = useState<any>([]);
    const [drpValue, setDrpValue] = useState<any[]>([])
    const [drpRolling, setDrpRolling] = useState<any>('rolling_21')
    const [chartData, setChartData] = useState<any>([])
    const [monthlyChartData, setMonthlyChartData] = useState<any>([])
    // const years = ['2025', '2024', '2023','2022', '2021', '2020', '2019', '2018']
    const years = [ {name: '2025', value : '2025'},
        {name: '2024', value : '2024'},
        {name: '2023', value : '2023'},
        {name: '2022', value : '2022'},
        {name: '2021', value : '2021'},
        {name: '2020', value : '2020'},
        {name: '2019', value : '2019'}
    ];
    const [exportData, setExportData] = useState<any>([]);
    const [selected_year, setSelectedYear] = useState<any>([])
    const [selected_year_tbl, setSelectedYearTbl ] = useState<any>('2024')
    const [startDate, setStartDate] = useState<any>('2019-04-09');
    const [endDate, setEndDate] = useState<any>(moment().format("YYYY-MM-DD"));
    const rolling_options = [{
        name: 'Rolling 21',value: 'rolling_21'},
        {name: 'Rolling 63', value: 'rolling_63'}, 
        {name: 'Rolling 252', value: 'rolling_252'}
    ];
    const filters = {
        s_symbol: { value: null, matchMode: FilterMatchMode.CONTAINS},
        s_code: { value: null, matchMode: FilterMatchMode.CONTAINS}
    };

    // const PreviewTableDataState = useSelector(
    //     (state: any) => state?.previewTableArr?.PreviewTableData
    //   );


    //-------------------CSV PREVIEW-------------//
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [selectedPreviewTableData, setSelectedPreviewTableData] = useState<any[]>([]);
    const [selectedPreviewTableColumns, setSelectedPreviewTableColumns] = useState<any[]>([]);
    const [selectedPreviewTableColumnMapping, setSelectedPreviewTableColumnMapping] = useState<any>({});
    const [selectedFileName, setSelectedFileName] = useState<string>("");


    const memorizedExportCSV = useCallback(generaliseExportCSV,[isModalOpen,selectedPreviewTableData]);
    // const onDownload = useCallback(() => memorizedExportCSV(selectedPreviewTableData,selectedPreviewTableColumnMapping,"MonthlyReturns.csv"), [memorizedExportCSV,selectedPreviewTableData]);
    

    // ----------- CHANGES FOR HEATMAP ---------------------//
    const [showRelatedHeatMap, setShowRelatedHeatMap] = useState<boolean>(false);
    const [mainHeatMap, setMainHeatMap] = useState<any>([]);
    const [subHeatMapData, setSubHeatMapData] = useState<any>([]);
    const [boxShadowSubItem, setBoxShadowSubItem] = useState<any>(null);
    const [prevVersion, setPrevVersion] = useState<any>('');

    const convertNullDataToNA = (e: any) => {
        if (e == null || e == 0.00 ) {
            return 'NA'
        }
        else {
            return e
        }
       }

    const rolling_chart = {
        title: {
          text: `${[drpValue]?.map((item:any) => item?.s_symbol)} - ${drpRolling.replace(/(\w)(\w*)/g,function(g0:any,g1:any,g2:any){return (g1.toUpperCase() + g2.toLowerCase()).replace("_", " ");})} Returns Vs Time Period`,
        },
        xAxis: {
          categories: chartData?.date,
          labels: {
            rotation: -90,
            steps:1000,
          }
        },
        tooltip: {
          valueDecimals: 2,
        },
        series: [
          {
            name: `${[drpValue]?.map((item:any) => item?.s_symbol)}`,
            data: chartData?.rolling_col,
            color: '#568ccd',
            negativeColor: 'red'
          }
        ],
        chart: {
          backgroundColor: 'transparent',
          height: 600,
          type : 'area',
          borderWidth: -1,
          spacingTop: 25
        },
        credits: { enabled: false },
        accessibility: {
          enabled: false
        },
        plotOptions: {
          series: {
              fillOpacity: 0.1
          },
        },
        legend: {
          align: 'right',
          verticalAlign: 'top',
          x: 0,
          y: 0
      },
      yAxis:{
        gridLineWidth : 0,
        title: {
            text: `Rolling Returns`
        }
      },
    };

    const monthly_chart = {
        title: {
          text: `${[drpValue]?.map((item:any) => item?.s_symbol)} - Monthly Return Vs Month`,
        },
        xAxis: {
          categories: monthlyChartData?.month,
          labels: {
            rotation: -90,
            steps:1000,
          }
        },
        tooltip: {
          valueDecimals: 2,
        },
        series: [
          {
            name: `${[drpValue]?.map((item:any) => item?.s_symbol)}`,
            data: monthlyChartData?.return_val,
            color: '#568ccd',
            negativeColor: 'red'
          }
        ],
        chart: {
          backgroundColor: "transparent",
          height: 600,
          type : 'column',
          borderWidth: -1,
          spacingTop: 25
        },
        credits: { enabled: false },
        accessibility: {
          enabled: false
        },
        plotOptions: {
          series: {
              fillOpacity: 0.1
          },
        },
        legend: {
          align: 'right',
          verticalAlign: 'top',
          x: 0,
          y: 0
      },
      yAxis:{
        gridLineWidth : 0,
        title: {
            text: 'Monthly Returns'
        }
      },
    };

    const handleButtonClick = (button: string) => {
        setHeatmapVersion('all');
        setAsset(type);
        setActiveButton(button);
        setSelectedComponent(button);
    };
    
    const getMonthlychartData = async () => {
        let response = await getMonthlyRollingChartValue(drpValue, selected_year, type, startDate, endDate)
            if (response?.month?.length >= 0 && response?.return_val?.length >= 0 ){
                setMonthlyChartData(response)
                
            }
    }

    useEffect(() => {
        setAsset(type);
        setViewCharts(false);
        setHeatmapVersion('all');
        setActiveButton('historicalEquity');
        setSelectedComponent('historicalEquity');
        setSelectedYear('2024')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type])

    useEffect(()=>{
        // if((newsSignals!=null) && (newsSignals?.length > 0)){
            let toggleID:any = document.getElementById('switch-rounded')
            if(toggleID !=null){
                if(returnType === 'reInvestment'){
                    toggleID.checked = true;
                }else{
                    toggleID.checked = false;
                }
            }
        // }
    },[type, activeButton])

    useEffect(() => {
        let contractMonth:any = (['equityMultiday','equityN50BANK'].includes(type) || type === 'stockPairIntraday') ? 12 : 1;
        let start_date:any = null;
        let end_date:any = null;
        setHeatmapPlPoints(0)
        let [filteredResponse]: any = handleFilterResponse()
        if (filteredResponse.length > 0) {
            if (Object.keys(filteredResponse[0])[0] === 'Current_contract') {
                if(['equityMultiday','equityN50BANK'].includes(type) || type === 'stockPairIntraday') {
                    contractMonth = 12
                }
                else {
                    contractMonth = 1
                }
            }
            else if (Object.keys(filteredResponse[0])[0] === 'No_of_months') {
                contractMonth = filteredResponse[0]['No_of_months']
            }
            else if ((Object.keys(filteredResponse[0])[0] === 'start_date') && (Object.keys(filteredResponse[1])[0] === 'end_date')) {
                start_date = filteredResponse[0]['start_date']
                end_date = filteredResponse[1]['end_date']
            }
        }

        const fetchingContractStartEndDate = async () => {
            setStartAndEndDate(null);
            if (start_date === null && end_date === null) {
                let asset: any = (type === 'commodityFutIntraday') ? 'GOLD-I.MCX' : type
                let contractDateResponse: any = await getStartEndDateSF(contractMonth, asset, type)
                setStartAndEndDate(contractDateResponse);
                
            }
            else {    
                setStartAndEndDate({ 'start_date': filterFinalObject?.start_date, 'end_date': filterFinalObject?.end_date });
            }
            setHeatmapVersion('all');
            setAsset(type);
            setPrevVersion('');
        }
        fetchingContractStartEndDate();
    }, [type, filterFinalObject])

    useEffect (() => {
        if(drpValue != undefined && drpRolling.length != 0){
            getRollingChartValues(drpValue, drpRolling)
            getRollingPdfExport(drpValue, drpRolling)
        }
    }, [drpValue, drpRolling, startDate, endDate])

    useEffect(() => {
        getMonthlychartData()
    },[drpValue, selected_year, startDate, endDate])

    //New added
    const getRollingPdfExport = async (symbol:any, rolling:any) =>  {

        let response = await getRollingPdf(symbol,rolling, type, startDate, endDate)
            if (response?.length >= 0){
                setExportData(response);
                console.log("ROLLING AGAIN",response);

            }
    }

    const handleFilterResponse = () => {
        let selectedResponse: any = [];
        let selectedDropdownVersion: any = [];
        setFilterDropdownVersion([]);
        if (Object.keys(filterFinalObject)?.length > 0) {
            Object.keys(filterFinalObject)?.map((item: any, index: any) => {
                if (['Current_contract', 'No_of_months', 'start_date', 'end_date']?.includes(item) && ((filterFinalObject[item] !== false))) {
                    selectedResponse.push({ [item]: filterFinalObject[item] })
                }
            })
            selectedDropdownVersion = Object.keys(filterFinalObject?.model_version)?.filter((item: any) => {
                return filterFinalObject?.model_version[item] !== false;
            })            
            setFilterDropdownVersion(selectedDropdownVersion);
        }
        return [selectedResponse, selectedDropdownVersion]
    }

    // const getRollingChartValues = async (symbol:any, rolling:any) =>  {

    //     let response = await getRollingChartValue(symbol,rolling, type, startDate, endDate)
    //         if (response?.date?.length >= 0){
    //             setChartData(response);
    //     }
    // }

    const getRollingChartValues = async (symbol:any, rolling:any) =>  {
        if (type !== 'equityN50BANK'){
            let response = await getRollingChartValue(symbol,rolling, type, startDate, endDate)
            if (response?.date?.length >= 0){
                setChartData(response);
        }}
        else if (type === 'equityN50BANK'){
            symbol = symbol.s_symbol + "_EB"
            let response = await getRollingChartValue(symbol,rolling, type, startDate, endDate)
            if (response?.date?.length >= 0){
                setChartData(response);
        }}
    }
    // const getMonthlyRollingReturn = async () => {
    //     let response = await getEquityReturnDetails(selected_year_tbl, type)
    //         if (response?.length >= 0){
    //             setCurrData(response);
    //             dispatch(setPreviewTableData(response))
    //             console.log("ROLLING",response);
                
                
    //         } 
    //         else {
    //             setCurrData([])
    //             dispatch(setPreviewTableData([]))
    //         }
        
    // }
    const getMonthlyRollingReturn = async () => {
        let response = await getEquityReturnDetails(selected_year_tbl, type)
            if (response?.length >= 0 && type !== 'equityN50BANK'){
                setCurrData(response);
                dispatch(setPreviewTableData(response))
                }
            else if  (response?.length >= 0 && type === 'equityN50BANK'){
                console.log("response of getMonthlyRollingReturn",response)
                response = response?.map((item: any) => ({...item,s_symbol: item.s_symbol?.split('_')[0],}));
                setCurrData(response);
                dispatch(setPreviewTableData(response))
            }
            else {
                setCurrData([])
                dispatch(setPreviewTableData([]))
            }
       
    }

    // const setDropdownOptions = async () => {
    //     let response = await getSymbolOptions(type)
    //         if (response?.length >= 0){
    //             setSymbolsOptions(response);
    //             setDrpValue(response?.[0])
    //         }
    //         else 
    //         {
    //             setSymbolsOptions([])
    //         }
    // }
    const setDropdownOptions = async () => {
        let response = await getSymbolOptions(type)
            if (response?.length >= 0){
                if (type === 'equityN50BANK'){
                    response = response.map((item: any) => ({...item,s_symbol: item.s_symbol?.split('_')[0],}))
                    setSymbolsOptions(response);
                    setDrpValue(response?.[0])
                }
                else{
                    setSymbolsOptions(response);
                    setDrpValue(response?.[0])                    
                }
            }
            else
            {
                setSymbolsOptions([])
            }
    }
    
    useEffect(() => {
        getMonthlyRollingReturn();
    }, [type, selected_year_tbl])
    
    useEffect( () => {
        let obj: any = {};
        let versionsResponse: any = handleVersion(type)
        setFilterDropdownVersion([])
        setVersions(versionsResponse)
        setDropdownOptions()
        versionsResponse.map((version: any, index: any) => (Object.assign(obj, { [version]: true })))
        setFilterData({ ...filterData, ...obj })
        console.log("This is the type ",type)
        try{
            if(type==='equityMultiday'){
                (async function fetchCodeAndSymbol(){
                    let codeAndSymbol:any = await getPrivilegedCodeAndSymbol();
                    if(!codeAndSymbol.error) {
                        setAllSymbols(codeAndSymbol?.data != null?(Object.values(codeAndSymbol?.data)):[]);
                        setPrivilegedCodeAndSymbol(codeAndSymbol?.data)
                    }
                    else setAllSymbols([]);
                })();
            }else if (type === 'equityN50BANK'){
                (async function fetchCodeAndSymbol(){
                    let codeAndSymbol:any = await getPrivilegedCodeAndSymbolBank();
                    console.log("codeAndSymbol::::", codeAndSymbol);
                    
                    if(!codeAndSymbol.error) {
                        setAllSymbols(codeAndSymbol?.data != null?(Object.values(codeAndSymbol?.data)):[]);
                        setPrivilegedCodeAndSymbol(codeAndSymbol?.data)
                    }
                    else setAllSymbols([]);
                })();
            }
            else{
                setAllSymbols(versionsResponse.map((item:string)=>item.slice(3)))
            }
        }catch(e){
            console.log("Error when try to get privilege code and symbol",e);
        }
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type])

    const historicalParamsSelector: any = useSelector((state: any) => {
        return state?.historicalParamsData?.paramsArray
    })

    let getTypeNameObj: any = {
        commodityFutIntraday: "Commodity Fut - Intraday",
        equityMultiday: "Equity - Multiday",
        equityN50NXT: "Equity - N50NXT",
        equityN50BANK: "Equity - BANK",
        forexFutIntraday: "Forex Fut - Intraday",
        forexFutMultiday: "Forex Fut - Multiday",
        forexOptIntraday: "Forex Opt - Intraday",
        stockFutIntraday: "Stock Fut - Intraday",
        stockIndexFutIntraday: "Stock Index Fut - Intraday",
        stockindexOptIntraday: "Stock Index Opt - Intraday",
        stockOptIntraday: "Stock Opt - Intraday",
        stockPairIntraday:"Stock Pair - Intraday"
    }

    useEffect(() => {
        if (startandEndDate !== null) {
            const fetchplPercentResponse: any = async () => {
                setHeatMapData([]);
                setMainHeatMap([]);
                setSubHeatMapData([]);

                let plPointsvalue: any = 0
                let plPercentApiResponse: any = await getPLPercentageResponse(startandEndDate?.start_date, startandEndDate?.end_date, asset, heatmapVersion, type, tradetype, filterDropdownVersion, returnType)
                if (plPercentApiResponse?.length > 0) {
                    plPercentApiResponse?.map((item: any) => {
                        return plPointsvalue += item?.sum
                    })
                    setHeatmapPlPoints(plPointsvalue)
                }
                if (plPercentApiResponse?.length > 1) {

                    setHeatMapData([{
                        "asset": type,
                        "pl_percentage":0,
                        "s_version": "all",
                        "start": startandEndDate?.start_date,
                        "end": startandEndDate?.end_date,
                        "tradetype": 'Total'
                    },...plPercentApiResponse])
                    setboxShadow('all');
                }
                else {
                    setHeatMapData(plPercentApiResponse)
                    setboxShadow(plPercentApiResponse?.s_version)
                }
            }
            fetchplPercentResponse()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type, startandEndDate, heatMapClicked, returnType])

    const tradesExports = (data: any, value:number) => {
        if(value === 1){
            const tradeDataToConvert = {
              data: currData,
              filename: `Monthly Return Details`,
              delimiter: ",",
              headers: [
                "Year",
                "Code",
                "Symbol",
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
              ],
          }
          csvDownload(tradeDataToConvert);
        }
        else{
            const tradeDataToConvert = {
              data: exportData,
              filename: `Rolling Summary (21 Days/63 Days/252 Days)`,
              delimiter: ",",
              headers: [
                "Symbol",
                "Date",
                "Rolling_21",
                "Rolling_63",
                "Rolling 252"
              ],
          } 
          csvDownload(tradeDataToConvert);
        }
      }

      useEffect(() => {
        if (showRelatedHeatMap && heatmapVersion !== 'all' && subHeatMapData.length === 0) {
            if (subHeatMapData.length > 0) {
                setBoxShadowSubItem(subHeatMapData[0]?.s_version);
                setHeatmapVersion(subHeatMapData[0]?.s_version);
                setAsset(subHeatMapData[0]?.asset);
            }
        }
    }, [showRelatedHeatMap]); 
    

    // useEffect(()=>{
    //     function groupAndSummarize(arr:any){
            
    //         const result:any = [];
    //         const groupedData:any = {};
    //         arr.forEach((item:any)=>{
    //             if (item?.identifier && typeof item?.identifier === "string"){
    //                 const baseIdentifier:any = item?.identifier?.split('-')[0];
                    
    //                 if(!groupedData[baseIdentifier]){
    //                     groupedData[baseIdentifier] = {
    //                         asset: item.asset,
    //                         identifier: baseIdentifier,
    //                         pl_percentage:0,
    //                         sum:0, 
    //                         pl_in_rs:0,
    //                         s_code: item?.s_code?.split('-')[0],
    //                         s_version: item?.s_version?.split('-')[0],
    //                     }
                        
    //                 }
    //                 groupedData[baseIdentifier].pl_percentage += item.pl_percentage || 0;
    //                 groupedData[baseIdentifier].sum += item.sum || 0;
    //                 groupedData[baseIdentifier].pl_in_rs += item.pl_in_rs || 0;
    //             }else{
    //                 groupedData[item.asset] = {...item}
    //             }
    //         })

    //         for(const key in groupedData){
    //             result.push(groupedData[key]);
    //         }
    //         return result;
    //     }
    //     if(heatMapData.length>0) setMainHeatMap(groupAndSummarize(heatMapData));
    // },[heatMapData]);

    useEffect(()=>{
        function groupAndSummarize(arr:any){
            const result:any = [];
            const groupedData:any = {};
            const countMap:any = {};
            arr.forEach((item:any)=>{
                if (item?.identifier && typeof item?.identifier === "string"){
                    const baseIdentifier:any = item?.identifier?.split('-')[0];
                    if(!groupedData[baseIdentifier]){
                        groupedData[baseIdentifier] = {
                            asset: item.asset,
                            identifier: baseIdentifier,
                            pl_percentage:0,
                            sum:0, 
                            pl_in_rs:0,
                            s_code: item?.s_code?.split('-')[0],
                            s_version: item?.s_version?.split('-')[0],
                        }
                        countMap[baseIdentifier] = 0;
                    }
                    groupedData[baseIdentifier].pl_percentage += item.pl_percentage || 0;
                    groupedData[baseIdentifier].sum += item.sum || 0;
                    groupedData[baseIdentifier].pl_in_rs += item.pl_in_rs || 0;
                    countMap[baseIdentifier]++
                }else{
                    groupedData[item.asset] = {...item}
                }
            })

            for(const key in groupedData){
                if(countMap[key]){
                    groupedData[key].pl_percentage /= countMap[key];
                    groupedData[key].sum /= countMap[key];
                    groupedData[key].pl_in_rs /= countMap[key];
                }
                result.push(groupedData[key]);
            }
            return result;
        }
        if(heatMapData.length>0) setMainHeatMap(groupAndSummarize(heatMapData));
    },[heatMapData]);


    const handleMainHeatMapClick = (data: any) => {
        
        if(prevVersion !== data.s_version){
            setShowRelatedHeatMap(true);
        }else setShowRelatedHeatMap(false);

        const modelCount:any = {};

        let filteredData = heatMapData.filter((item: any) => {
            if(item.s_version?.split('-').length>1){
                modelCount[item.s_version?.split('-')[0]] = true;
            }
            return item.s_version?.split('-')[0] === data?.s_version?.split('-')[0]
            }
        );
 
        if (filteredData.length > 0 && modelCount[data?.s_version?.split('-')[0]]===true) {
            setSubHeatMapData(filteredData);
            setBoxShadowSubItem(filteredData[0]?.s_version);
            setHeatmapVersion(filteredData[0]?.s_version);
            setAsset(filteredData[0]?.asset);
            setFilterDropdownVersion([]);
        } else {
            setSubHeatMapData([]);
            setHeatmapVersion(data?.s_version);
            setAsset(data?.asset);
            setFilterDropdownVersion([]);
        }
        if(prevVersion === data.s_version) setPrevVersion('');
        else setPrevVersion(data?.s_version);
    
        setTradetype(data?.s_version?.slice(2, 3) === 'O' ? 'short' : 'Total');
    };
    

    return( <>
    <div style={{width:'97vw'}}>
        {['equityMultiday','equityN50BANK','stockindexOptIntraday']?.includes(type) && <div className="historical_buttons_group1">
            <div>
                <button className= "btn_header1" onClick={() => handleButtonClick('historicalEquity')} id = {activeButton === 'historicalEquity' ? 'activeHistorical' : 'inactiveHistorical' }>Trade Statistics</button>
                <button className= "btn_header1" onClick={() => handleButtonClick('strategy')} id = {activeButton === 'strategy' ? 'activePerformance' : 'inactivePerformance' } >Assetwise Statistics</button>
            </div>
            {activeButton === 'strategy' && <span className='dropdown1_headerName_title'>Model Strategy Performance</span>}

        </div>}
        
        {selectedComponent === 'historicalEquity'?(
        <div className="container-custom whole_container hist-performance-layout">
            <Row className='hist-performance-upper-row'  >
                <span className="product-type" >{getTypeNameObj[type]}</span>
                <div className="filter">
                    <span className="filterSelectionDate">
                        <span className="filterSelectionDateBox">{moment(startandEndDate?.start_date).format("MMM Do, YYYY")}</span> 
                        <MdArrowRightAlt /> 
                        <span className="filterSelectionDateBox">{moment(startandEndDate?.end_date).format("MMM Do, YYYY")}</span>
                    </span>
                    <button className="filterBtn" onClick={() => { setFilter(prevFilter => !prevFilter) }}><FaFilter /></button>
                    {filter && <Filter type={type} setCurrContractDiv={setCurrContractDiv} dateFilter={dateFilter} setDateFilter={setDateFilter} setFilter={setFilter} setFilterData={setFilterData} filterData={filterData} versions={versions} setFilterFinalObject={setFilterFinalObject} privilegedCodeAndSymbol={privilegedCodeAndSymbol}/>}
                </div>
            </Row>

            {['equityMultiday','equityN50BANK'].includes(type) ? <div className="assest_row_returnType">
                <div className="TotalAsset">
                    {/* <div className="total_symbol1">
                        {<div className='toggleDiv'>
                            <span className="investmentType">Investment</span>
                            <span className="switch">
                                <input id="switch-rounded" type="checkbox" onChange={(e: any) => {
                                    if (e.target.checked) {
                                        setReturnType('reInvestment')
                                    } else {
                                        setReturnType('noReInvestment')
                                    }
                                }} />
                                <label htmlFor="switch-rounded"></label>
                            </span>
                            <span className="investmentType">Reinvestment</span>
                        </div>}
                    </div> */}
                </div>
            </div>: <div className="assest_row"></div>}

            <div className="heamapDesign">
                {false ?
                    <div className="HeatMap-spinner-container" >
                        {/* <BeatLoader color="#dc9948" size={10} /> */}
                    </div> :
                    <HeatMap 
                        heatMapData = {mainHeatMap} 
                        boxShadow = {boxShadow} 
                        setboxShadow = {setboxShadow} 
                        handleHeatMapClick={(data:any)=> {
                            setSubHeatMapData([]);
                            handleMainHeatMapClick(data);
                        }}
                        />}
                {showRelatedHeatMap && 
                    <RelatedHeatMap subHeatMapData={subHeatMapData}
                                boxShadow={boxShadowSubItem} 
                                setboxShadow={setBoxShadowSubItem} 
                                handleHeatMapClick={(data: any) => {   
                                    setHeatmapVersion(data?.s_version);
                                    setAsset(data?.asset);
                                    setFilterDropdownVersion([]);
                                    if (heatmapVersion?.slice(2, 3) === 'O') setTradetype('short');
                                    else setTradetype('Total');
                                }} 
                    />
                }
            </div>
            <div style={{ height: 10 }}></div>
            <div className={`${currContractDiv || ['equityMultiday','equityN50BANK'].includes(type)? 'curr_contract_card_row' : 'card_row'}`}>
                <div className={`${currContractDiv ||['equityMultiday','equityN50BANK'].includes(type)? 'col-lg-4_currContract' : 'col-lg-4'}`} >
                    {false ?
                        <Card className="custom-card card2">
                            <div className="spinner-container" style={{ height: '55rem', justifyContent: "center", alignItems: "center" }}>
                                {/* <BeatLoader color="#dc9948" /> */}
                            </div>
                        </Card> :
                        false ?
                            <Card className="custom-card card2">
                                <div className="spinner-container" style={{ height: '5rem', justifyContent: "center", alignItems: "center" }}>
                                    {/* <BeatLoader color="#dc9948" /> */}

                                </div>
                            </Card> : <NoOfCallsCard currContractDiv={currContractDiv} filterDropdownVersion={filterDropdownVersion} type={type} startandEndDate={startandEndDate} heatmapVersion={heatmapVersion} asset={asset} />}
                </div>
                <div className={`${currContractDiv ||['equityMultiday','equityN50BANK'].includes(type)? 'col-lg-4_currContract' : 'col-lg-4'}`} >
                    {false ?
                        <Card className="custom-card card2">
                            <div className="spinner-container" style={{ height: '55rem', justifyContent: "center", alignItems: "center" }}>
                                {/* <BeatLoader color="#dc9948" /> */}
                            </div>
                        </Card> : false ?
                            <Card className="custom-card card2">
                                <div className="spinner-container" style={{ height: '5rem', justifyContent: "center", alignItems: "center" }}>
                                    {/* <BeatLoader color="#dc9948" /> */}
                                </div>
                            </Card> : <SuccessRatioCard currContractDiv={currContractDiv} filterDropdownVersion={filterDropdownVersion} type={type} startandEndDate={startandEndDate} heatmapVersion={heatmapVersion} asset={asset} />}
                </div>
                <div className={`${currContractDiv ||['equityMultiday','equityN50BANK'].includes(type)? 'col-lg-4_currContract' : 'col-lg-4'}`} >
                    {false ?
                        <Card className="custom-card card2">
                            <div className="spinner-container" style={{ height: '55rem', width: "100%", justifyContent: "center", alignItems: "center" }}>
                                {/* <BeatLoader color="#dc9948" /> */}
                            </div>
                        </Card> : false ?
                            <Card className="custom-card card2">
                                <div className="spinner-container" style={{ height: '5rem', width: "100%", justifyContent: "center", alignItems: "center" }}>
                                    {/* <BeatLoader color="#dc9948" /> */}
                                </div>
                            </Card> : <PLCard hetmapPlPoints={hetmapPlPoints} currContractDiv={currContractDiv} filterDropdownVersion={filterDropdownVersion} type={type} startandEndDate={startandEndDate} heatmapVersion={heatmapVersion} asset={asset} tradetype={tradetype} heatMapData={heatMapData}/>}
                </div>
            </div>

            <HistoricalDataTable filterDropdownVersion={filterDropdownVersion} type={type} startandEndDate={startandEndDate} heatmapVersion={heatmapVersion} asset={asset} tradetype={tradetype} heatMapData={heatMapData}/>

            <div className={`charts_main_div ${!viewCharts ? "" : 'charts_main_div_close'}`} onClick={() => { setViewCharts(true) }}>
                {!viewCharts ?
                    <>
                        <span className="viewChartsSvgImg"><IoBarChartSharp /></span>
                        <span className='view_charts'>View Charts</span>
                    </> : " "
                }
            </div>

            {viewCharts ?
                <Card className="historicalCards" >
                    <Card.Body >
                        {(true ?
                            <>
                                <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                    <div className="view_charts_row_closeBtn"  >
                                        <span onClick={() => { setViewCharts(false) }}><RxCross2 /></span>
                                    </div>
                                </div>
                            </>
                            : " ")}
                        <div className="view_charts_row">
                            {true && <div className="col-lg-6">
                                {false ?
                                    <div className="Hist_spinner-container" >
                                        {/* <BeatLoader color="#dc9948" /> */}
                                    </div> :
                                    <TargetSlChart type={type} startandEndDate={startandEndDate} selectedRowData={historicalParamsSelector} />}
                            </div>}

                            <div className="col-lg-6">
                                {false ?
                                    <div className="Hist_spinner-container" >
                                        {/* <BeatLoader color="#dc9948" /> */}
                                    </div>
                                    : <MtmChart type={type} mtmResponse={mtmDrawdownResponse} />}
                            </div>
                            <div className="col-lg-6">
                                {false ?
                                    <div className="Hist_spinner-container" >
                                        {/* <BeatLoader color="#dc9948" /> */}
                                    </div>
                                    : <DrawdownChart type={type} selectedRowData={historicalParamsSelector} setMtmDrawdownResponse={setMtmDrawdownResponse} />}
                            </div>
                        </div>
                    </Card.Body>
                </Card>
                : " "}
        </div>):['equityMultiday','equityN50BANK'].includes(type)? (<Performance codes={allSymbols} />) : type === 'stockindexOptIntraday' ? (<OptionPerformance />) : ''}
    
        { ['equityMultiday','equityN50BANK', 'stockindexOptIntraday']?.includes(type) && selectedComponent === 'historicalEquity'? 
        <>
       <GeneralisePreviewTable
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          columnHeader={selectedPreviewTableColumns}
          tableData={selectedPreviewTableData}
          onDownload={()=>{memorizedExportCSV(selectedPreviewTableData, selectedPreviewTableColumnMapping, selectedFileName)}}
        />
            <div className="charts_main_div outer-table">
                <div className="monthly-return">
                    <div className="text-return">Monthly Returns
                        <div className="drpdwn ">
                            <Dropdown value={selected_year_tbl} onChange={(e) => {setSelectedYearTbl(e.target.value)}} options={years} optionLabel="name" placeholder="Select Rolling" checkmark={true} highlightOnSelect={false} />
                            <Button 
                            type="button"
                            icon="pi pi-download" 
                            rounded 
                            onClick={()=>{
                                setSelectedPreviewTableData(currData);
                                setSelectedPreviewTableColumns(monthlyReturnsMappingTableHeader);
                                setSelectedPreviewTableColumnMapping(monthlyReturnsMapping);
                                setSelectedFileName("Monthly_Returns.csv")
                                setIsModalOpen(true);
                            
                            }}
                            className='button1' />
                        </div>
                    </div>
                    
                </div>
                <div className="inner-table-2 adviceStatus_table">
                <DataTable value = {currData} scrollable resizableColumns reorderableRows onRowReorder={(e) => setCurrData(e.value)} columnResizeMode="expand"
                    stripedRows filters={filters} sortMode="multiple">
                        <Column className="reorder" rowReorder style={{ width: "3rem" }} />
                            <Column 
                                field= "s_symbol"  
                                header= "Symbol" filter filterPlaceholder="Search Symbol"
                                style={{ minWidth: '120px'}} sortable>
                            </Column> 
                            <Column 
                                field= "s_code"  
                                header= "Code" 
                                style={{ minWidth: '120px'}} sortable>
                            </Column> 
                            <Column 
                                field= "year"  
                                header= "Year" 
                                style={{ minWidth: '120px'}} >
                            </Column> 
                            <Column 
                                field= "Jan"  
                                header= "January" 
                                style={{ minWidth: '120px'}} sortable
                                body={(e:any)=> <div>{convertNullDataToNA(e['Jan'])}</div>}
                                >
                            </Column> 
                            <Column 
                                field= "Feb"  
                                header= "February" 
                                style={{ minWidth: '120px'}} sortable
                                body={(e:any)=> <div>{convertNullDataToNA(e['Feb'])}</div>}
                                >
                            </Column> 
                            <Column 
                                field= "Mar"  
                                header= "March" 
                                style={{ minWidth: '120px'}} sortable
                                body={(e:any)=> <div>{convertNullDataToNA(e['Mar'])}</div>}
                                >
                            </Column>
                            <Column 
                                field= "Apr"  
                                header= "April" 
                                style={{ minWidth: '120px'}} sortable
                                body={(e:any)=> <div>{convertNullDataToNA(e['Apr'])}</div>}
                                >
                            </Column> 
                            <Column 
                                field= "May"  
                                header= "May" 
                                style={{ minWidth: '120px'}} sortable
                                body={(e:any)=> <div>{convertNullDataToNA(e['May'])}</div>}
                                >
                            </Column> 
                            <Column 
                                field= "Jun"  
                                header= "June" 
                                style={{ minWidth: '120px'}} sortable
                                body={(e:any)=> <div>{convertNullDataToNA(e['Jun'])}</div>}
                                >
                            </Column> 
                            <Column 
                                field= "Jul"  
                                header= "July" 
                                style={{ minWidth: '120px'}} sortable
                                body={(e:any)=> <div>{convertNullDataToNA(e['Jul'])}</div>}
                                >
                            </Column> 
                            <Column 
                                field= "Aug"  
                                header= "August" 
                                style={{ minWidth: '120px'}} sortable
                                body={(e:any)=> <div>{convertNullDataToNA(e['Aug'])}</div>}
                                >
                            </Column> 
                            <Column 
                                field= "Sep"  
                                header= "September" 
                                style={{ minWidth: '120px'}} sortable
                                body={(e:any)=> <div>{convertNullDataToNA(e['Sep'])}</div>}
                                >
                            </Column> 
                            <Column 
                                field= "Oct"  
                                header= "October" 
                                style={{ minWidth: '120px'}} sortable
                                body={(e:any)=> <div>{convertNullDataToNA(e['Oct'])}</div>}
                                >
                            </Column> 
                            <Column 
                                field= "Nov"  
                                header= "November" 
                                style={{ minWidth: '120px'}} sortable
                                body={(e:any)=> <div>{convertNullDataToNA(e['Nov'])}</div>}
                                >
                            </Column> 
                            <Column 
                                field= "Dec"  
                                header= "December" 
                                style={{ minWidth: '120px'}} sortable
                                body={(e:any)=> <div>{convertNullDataToNA(e['Dec'])}</div>}
                                >
                            </Column>  

                    </DataTable>
                </div>

                <div className="row historicalCards return-chart card-body">
                    <div className="center-drpdwn">
                        <Dropdown style={{width:"13rem",float: "left"}} value={drpValue} onChange={(e) => {setDrpValue(e.target.value)}} options={symbolsOptions} optionLabel="s_symbol" placeholder="Select Symbol" checkmark={true} highlightOnSelect={false} />
                        <div className="date-picker-charts">
                            <CustomDateRange backStartDate={startDate} setBackStartDate={setStartDate} backEndDate={endDate} setBackEndDate={setEndDate} />
                        </div>
                    </div>
                    <div className="chart-area">
                        <div className="rolling-chart">
                            <div className="drpdwn">
                                <Dropdown value={drpRolling} onChange={(e) => {setDrpRolling(e.target.value)}} options={rolling_options} optionLabel="name" placeholder="Select Rolling" checkmark={true} highlightOnSelect={false} />
                                <Button type="button" icon="pi pi-download" rounded
                                   onClick={()=>{
                                    setSelectedPreviewTableData(exportData);
                                    setSelectedPreviewTableColumns(
                                        type === "stockindexOptIntraday" ? optionsRollingMappingTableHeader : rollingMappingTableHeader
                                      );
                                      
                                    setSelectedPreviewTableColumnMapping(type === "stockindexOptIntraday" ? optionsRollingMapping : rollingMapping);
                                    setSelectedFileName("Rolling.csv")
                                    setIsModalOpen(true);
                                
                                }} 
                                 className='button1' />
                                </div>
                            <div style={{paddingTop: "3.2rem"}}> <HighchartsReact highcharts={Highcharts} oneToOne={true} options={rolling_chart} /></div>
                        </div>
                        <div className="monthly-chart">
                        <div>  <HighchartsReact highcharts={Highcharts} oneToOne={true} options={monthly_chart} /></div>
                    </div>
                </div>
            </div>
            </div>
            

        </> : <></>}
        </div>
    
    
    </>
    )
}


export default Historical;